import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'electronic-control-room',
    name: 'ElectronicControlRoom',
    component: () => import('~/views/electronic-control-room/ElectronicControlRoom.vue'),
    meta: { title: 'Электронная диспетчерская' }
  },

  /* -------------------------------------------------------------------------*/
  /* Reports                                                                  */
  /* -------------------------------------------------------------------------*/

  {
    path: 'electronic-control-room/ads-analitical-report',
    name: 'AdsAnaliticalReport',
    component: () => import('~/views/electronic-control-room/reports/AdsAnaliticalReport.vue'),
    meta: { title: 'Анализ поступивших заявок' }
  },
  {
    path: 'electronic-control-room/specific-services-report',
    name: 'SpecifiedServicesReport',
    component: () => import('~/views/electronic-control-room/reports/SpecifiedServicesReport.vue'),
    meta: { title: 'Эксперт отчет по услугам' }
  },
  {
    path: 'electronic-control-room/request-division-report',
    name: 'RequestDivisionReport',
    component: () => import('~/views/electronic-control-room/reports/RequestDivisionReport.vue'),
    meta: { title: 'Эксперт отчет по заявкам, подразделениям' }
  },
  {
    path: 'electronic-control-room/request-date-report',
    name: 'RequestDateReport',
    component: () => import('~/views/electronic-control-room/reports/RequestDateReport.vue'),
    meta: { title: 'Эксперт отчет заявки по датам' }
  },
  {
    path: 'electronic-control-room/phonograms-report',
    name: 'PhonogramsReport',
    component: () => import('~/views/electronic-control-room/reports/PhonogramsReport.vue'),
    meta: { title: 'Реестр телефонограмм' }
  },
  {
    path: 'electronic-control-room/materials-consumption-report',
    name: 'MaterialsConsumptionReport',
    component: () => import('~/views/electronic-control-room/reports/MaterialsConsumptionReport.vue'),
    meta: { title: 'Отчет по расходованию материалов' }
  },
  {
    path: 'electronic-control-room/idents-with-electronic-bills-report',
    name: 'IdentsWithElectronicBillsReport',
    component: () => import('~/views/electronic-control-room/reports/IdentsWithElectronicBillsReport.vue'),
    meta: { title: 'Лицевые счета, получающие квитанции в эл. виде' }
  },
  {
    path: 'electronic-control-room/idents-with-electronic-bills-changes-report',
    name: 'IdentsWithElectronicBillsChangesReport',
    component: () => import('~/views/electronic-control-room/reports/IdentsWithElectronicBillsChangesReport.vue'),
    meta: { title: 'Лицевые счета, изменившие галку согласия получать квитанции в электронном виде' }
  },
  {
    path: 'electronic-control-room/deadline-report',
    name: 'DeadlineReport',
    component: () => import('~/views/electronic-control-room/reports/DeadlineReport.vue'),
    meta: { title: 'Отчет по дедлайну' }
  },
  {
    path: 'electronic-control-room/calls-report',
    name: 'CallsReport',
    component: () => import('~/views/electronic-control-room/reports/CallsReport.vue'),
    meta: { title: 'Эксперт отчет по звонкам' }
  },
  {
    path: 'electronic-control-room/ads-yammers-requests-report',
    name: 'AdsYammerRequestsReport',
    component: () => import('~/views/electronic-control-room/reports/AdsYammerRequestsReport.vue'),
    meta: { title: 'Жалобы и обращения' }
  },
  {
    path: 'electronic-control-room/tasks-report',
    name: 'TasksReport',
    component: () => import('~/views/electronic-control-room/reports/TasksReport.vue'),
    meta: { title: 'Отчет по задачам' }
  },
  {
    path: 'electronic-control-room/ads-requests-phones-report',
    name: 'AdsRequestsPhonesReport',
    component: () => import('~/views/electronic-control-room/reports/AdsRequestsPhonesReport.vue'),
    meta: { title: 'Телефоны из заявок' }
  },
  {
    path: 'electronic-control-room/ads-requests-performing-report',
    name: 'AdsRequestsPerformingReport',
    component: () => import('~/views/electronic-control-room/reports/AdsRequestsPerformingReport.vue'),
    meta: { title: 'Заявки по исполнителям' }
  },
  {
    path: 'electronic-control-room/eds-mo-incoming-requests-report',
    name: 'EdsMoIncomingRequestsReport',
    component: () => import('~/views/electronic-control-room/reports/EdsMoIncomingRequestsReport.vue'),
    meta: { title: 'Отчет по источнику заявок за период' }
  },
  {
    path: 'electronic-control-room/ads-pass-journal-report',
    name: 'AdsPassJournalReport',
    component: () => import('~/views/electronic-control-room/reports/AdsPassJournalReport.vue'),
    meta: { title: 'Журнал оформленных заявок на пропуск' }
  },
  {
    path: 'electronic-control-room/utility-shutdowns-report',
    name: 'UtilityShutdownsReport',
    component: () => import('~/views/electronic-control-room/reports/UtilityShutdownsReport.vue'),
    meta: { title: 'Журнал отключения коммунальных ресурсов' }
  },
  {
    path: 'electronic-control-room/messages-to-shareholder-telegram-report',
    name: 'MessagesToShareholderTelegramReport',
    component: () => import('~/views/electronic-control-room/reports/MessagesToShareholderTelegramReport.vue'),
    meta: { title: 'Отчет по обращениям к директору в телеграм' }
  },
  {
    path: 'electronic-control-room/ads-my-performed-journal-report',
    name: 'AdsMyPerformedJournalReport',
    component: () => import('~/views/electronic-control-room/reports/AdsMyPerformedJournalReport.vue'),
    meta: { title: 'Мои выполненные заявки за период' }
  },
  {
    path: 'electronic-control-room/analytical-reports/help-dispatcher-info-report',
    name: 'HelpDispatcherInfoReport',
    component: () => import('~/views/electronic-control-room/reports/HelpDispatcherInfoReport.vue'),
    meta: { title: 'Информация в помощь диспетчеру' }
  },
  {
    path: 'electronic-control-room/ads-journal-report',
    name: 'AdsJournalReport',
    component: () => import('~/views/electronic-control-room/reports/AdsJournalReport.vue'),
    meta: { title: 'Журнал заявок' }
  },
  {
    path: 'electronic-control-room/ads-journal-capital-invest-report',
    name: 'AdsJournalCapitalInvestReport',
    component: () => import('~/views/electronic-control-room/reports/AdsJournalCapitalInvestReport.vue'),
    meta: { title: 'Журнал заявок (вариант 2)' }
  },
  {
    path: 'electronic-control-room/paid-requests-report',
    name: 'PaidRequestsReport',
    component: () => import('~/views/electronic-control-room/reports/PaidRequestsReport.vue'),
    meta: { title: 'Отчет по платным заявкам' }
  },
  {
    path: 'electronic-control-room/ads-call-statistics-report',
    name: 'AdsCallsStatisticsReport',
    component: () => import('~/views/electronic-control-room/reports/AdsCallsStatisticsReport.vue'),
    meta: { title: 'Статистика звонков' }
  },
  {
    path: 'electronic-control-room/ads-mark-overview-report',
    name: 'AdsMarksOverviewReport',
    component: () => import('~/views/electronic-control-room/reports/AdsMarksOverviewReport.vue'),
    meta: { title: 'Оценка удовлетворенности' }
  },
  {
    path: 'electronic-control-room/ads-incoming-requests-report',
    name: 'AdsIncomingRequestsReport',
    component: () => import('~/views/electronic-control-room/reports/AdsIncomingRequestsReport.vue'),
    meta: { title: 'Отчет по поступившим обращениям в диспетчерскую службу' }
  },
  {
    path: 'electronic-control-room/test-multi-select-report',
    name: 'TestMultiSelectReport',
    component: () => import('~/views/electronic-control-room/reports/TestMultiSelectReport.vue'),
    meta: { title: 'Тестовый отчет с мультивыбором' }
  },
  {
    path: 'electronic-control-room/ask-for-mark-calls-report',
    name: 'AskForMarkCallsReport',
    component: () => import('~/views/electronic-control-room/reports/AskForMarkCallsReport.vue'),
    meta: { title: 'Отчет по обзвонам робота-оценщика' }
  },
  {
    path: 'electronic-control-room/ads-missed-call-report',
    name: 'AdsMissedCallReport',
    component: () => import('~/views/electronic-control-room/reports/AdsMissedCallReport.vue'),
    meta: { title: 'Отчет по пропущенным звонкам' }
  },
  {
    path: 'electronic-control-room/last-users-activity-report',
    name: 'LastUsersActivityReport',
    component: () => import('~/views/electronic-control-room/reports/LastUsersActivityReport.vue'),
    meta: { title: 'Отчет по последней активности пользователей сотрудников' }
  },
  {
    path: 'electronic-control-room/last-users-activity-report/neural-network-types-report',
    name: 'NeuralNetworkTypesReport',
    component: () => import('~/views/electronic-control-room/reports/NeuralNetworkTypesReport.vue'),
    meta: { title: 'Отчет по результатам работы нейросети' }
  },
  {
    path: 'electronic-control-room/acceptance-acts-requests-report',
    name: 'AcceptanceActsRequestsReport',
    component: () => import('~/views/electronic-control-room/reports/AcceptanceActsRequestsReport.vue'),
    meta: { title: 'Прием-передача помещений' }
  },
  {
    path: 'electronic-control-room/auto-move-settings-report',
    name: 'AutoMoveSettingsReport',
    component: () => import('~/views/electronic-control-room/reports/AutoMoveSettingsReport.vue'),
    meta: { title: 'Настройки автоперевода заявок' }
  },
  {
    path: 'electronic-control-room/ads-replies-to-resident-report',
    name: 'AdsRepliesToResidentReport',
    component: () => import('~/views/electronic-control-room/reports/AdsRepliesToResidentReport.vue'),
    meta: { title: 'Отчет по отправленным комментариям жителям' }
  },
  // {
  //   path: 'electronic-control-room/ads-employee-geolocation-report',
  //   name: 'AdsEmployeeGeolocation',
  //   component: () => import('~/views/electronic-control-room/reports/AdsEmployeeGeolocation.vue'),
  //   meta: { title: 'Отчет по геолокации сотрудников' }
  // },

  /* -------------------------------------------------------------------------*/
  /* Lists                                                                    */
  /* -------------------------------------------------------------------------*/

  // Services with recording
  {
    path: 'electronic-control-room/services-with-recording',
    name: 'ServicesWithRecording',
    component: () => import('~/views/electronic-control-room/lists/services-with-recording/ServicesWithRecording.vue'),
    meta: { title: 'Сервисы с записью' }
  },
  
  {
    path: 'electronic-control-room/services-with-recording/detail/:id?',
    name: 'ServiceWithRecording',
    component: () => import('~/views/electronic-control-room/list-items/services-with-recording/ServiceWithRecording.vue'),
    meta: { title: 'Сервис с записью' }
  },

  {
    path: 'electronic-control-room/services-with-recording/services-with-recording-slots/:id?',
    name: 'ServicesWithRecordingSlots',
    component: () => import('~/views/electronic-control-room/lists/services-with-recording/ServicesWithRecordingSlots.vue'),
    meta: { title: 'График работы сотрудников' }
  },

  {
    path: 'electronic-control-room/services-with-recording/services-with-recording-slots-journal-for-day/:id?',
    name: 'ServicesWithRecordingSlotsJournalForDay',
    component: () => import('~/views/electronic-control-room/lists/services-with-recording/ServicesWithRecordingSlotsJournalForDay.vue'),
    meta: { title: 'Журнал записей' }
  },

  {
    path: 'electronic-control-room/services-with-recording-report',
    name: 'ServicesWithRecordingReport',
    component: () => import('~/views/electronic-control-room/reports/ServicesWithRecordingReport.vue'),
    meta: { title: 'Статистика по сервисам с записью' }
  },

  {
    path: 'electronic-control-room/services-with-recording-journal-report',
    name: 'ServicesWithRecordingJournalReport',
    component: () => import('~/views/electronic-control-room/reports/ServicesWithRecordingJournalReport.vue'),
    meta: { title: 'Отчет по журналу записи' }
  },

  // Addresses
  {
    path: 'electronic-control-room/accounts',
    name: 'ElectronicControlRoom.Accounts',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomAccounts.vue'),
    meta: { title: 'Лицевые счета' }
  },

  {
    path: 'electronic-control-room/accounts/detail/:id?',
    name: 'ElectronicControlRoom.Account',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomAccount.vue'),
    meta: { title: 'Лицевой счет' }
  },

  {
    path: 'electronic-control-room/houses',
    name: 'ElectronicControlRoomHouses',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomHouses.vue'),
    meta: { title: 'Дома' }
  },

  {
    path: 'electronic-control-room/houses/detail/:id?',
    name: 'ElectronicControlRoomHouse',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomHouse.vue'),
    meta: { title: 'Дом' }
  },
	  {
    path: 'electronic-control-room/houses/detail/:parentId/entrances',
    name: 'ElectronicControlRoomEntrancesForHouse',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomEntrancesForHouse.vue'),
    meta: { title: 'Подъезды' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/entrances/detail/:id?',
    name: 'ElectronicControlRoomEntranceForHouse',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomEntranceForHouse.vue'),
    meta: { title: 'Подъезд' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/meters',
    name: 'ElectronicControlRoomHouseMetersForHouse',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomHouseMetersForHouse.vue'),
    meta: { title: 'ОДПУ' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/meters/detail/:id?',
    name: 'ElectronicControlRoomHouseMeterForHouse',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomHouseMeterForHouse.vue'),
    meta: { title: 'ОДПУ' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/cameras',
    name: 'ElectronicControlRoomHouseCamerasForHouse',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomHouseCamerasForHouse.vue'),
    meta: { title: 'Камеры' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/cameras/detail/:id?',
    name: 'ElectronicControlRoomHouseCameraForHouse',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomHouseCameraForHouse.vue'),
    meta: { title: 'Камера' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/lifts',
    name: 'ElectronicControlRoomLiftsForHouse',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomLiftsForHouse.vue'),
    meta: { title: 'Лифты' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/meters/detail/:id/meter-values',
    name: 'ElectronicControlRoomHouseMeterValuesForHouse',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomHouseMeterValuesForHouse.vue'),
    meta: { title: 'Показания ОДПУ' }
  },
  {
    path: 'electronic-control-room/houses/detail/:parentId/meters/detail/:id/meter-verifications',
    name: 'ElectronicControlRoomHouseMeterVerificationsForHouse',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomHouseMeterVerificationsForHouse.vue'),
    meta: { title: 'Поверки ОДПУ' }
  },

  {
    path: 'electronic-control-room/premises',
    name: 'ElectronicControlRoom.Premises',
    component: () => import('~/views/owners-offices/lists/owners-lists/OwnersOfficesPremises.vue'),
    meta: { title: 'Помещения' }
  },

  {
    path: 'electronic-control-room/rooms',
    name: 'ElectronicControlRoom.Rooms',
    component: () => import('~/views/electronic-control-room/lists/addresses/Rooms.vue'),
    meta: { title: 'Комнаты' }
  },

  {
    path: 'electronic-control-room/rooms/detail/:id?',
    name: 'ElectronicControlRoom.Room',
    component: () => import('~/views/electronic-control-room/list-items/addresses/Room.vue'),
    meta: { title: 'Комната' }
  },

  {
    path: 'electronic-control-room/groups-of-districts',
    name: 'ElectronicControlRoomGroupsOfDistricts',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomGroupsOfDistricts.vue'),
    meta: { title: 'Группы районов' }
  },

  {
    path: 'electronic-control-room/groups-of-districts/detail/:id?',
    name: 'ElectronicControlRoomGroupOfDistricts',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomGroupOfDistricts.vue'),
    meta: { title: 'Группа районов' }
  },

  {
    path: 'electronic-control-room/home-groups',
    name: 'ElectronicControlRoomHomeGroups',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomHomeGroups.vue'),
    meta: { title: 'Районы' }
  },

  {
    path: 'electronic-control-room/home-groups/detail/:id?',
    name: 'ElectronicControlRoomHomeGroup',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomHomeGroup.vue'),
    meta: { title: 'Район' }
  },

  {
    path: 'electronic-control-room/district-divisions',
    name: 'ElectronicControlRoomDistrictDivisions',
    component: () => import('~/views/electronic-control-room/lists/addresses/ElectronicControlRoomDistrictDivisions.vue'),
    meta: { title: 'Дивизионы групп районов' }
  },

  {
    path: 'electronic-control-room/district-divisions/detail/:id?',
    name: 'ElectronicControlRoomDistrictDivision',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ElectronicControlRoomDistrictDivision.vue'),
    meta: { title: 'Дивизион групп районов' }
  },

  // Requests

  {
    path: 'electronic-control-room/request-source-types',
    name: 'RequestSourceTypes',
    component: () => import('~/views/electronic-control-room/lists/requests/RequestSourceTypes.vue'),
    meta: { title: 'Типы источника заявок' }
  },
  {
    path: 'electronic-control-room/request-source-types/detail/:id?',
    name: 'RequestSourceType',
    component: () => import('~/views/electronic-control-room/list-items/requests/RequestSourceType.vue'),
    meta: { title: 'Тип источника заявок' }
  },

  {
    path: 'electronic-control-room/request-types',
    name: 'ElectronicControlRoom.RequestTypes',
    component: () => import('~/views/electronic-control-room/lists/requests/RequestTypes.vue'),
    meta: { title: 'Типы заявок' }
  },
  {
    path: 'electronic-control-room/request-types/detail/:id?',
    name: 'ElectronicControlRoom.RequestType',
    component: () => import('~/views/electronic-control-room/list-items/requests/RequestType.vue'),
    meta: { title: 'Тип заявок' }
  },

  {
    path: 'electronic-control-room/malfunction-types',
    name: 'ElectronicControlRoom.MalfunctionTypes',
    component: () => import('~/views/electronic-control-room/lists/requests/MalfunctionTypes.vue'),
    meta: { title: 'Виды неисправностей' }
  },
  {
    path: 'electronic-control-room/malfunction-types/detail/:id?',
    name: 'ElectronicControlRoom.MalfunctionType',
    component: () => import('~/views/electronic-control-room/list-items/requests/MalfunctionType.vue'),
    meta: { title: 'Вид неисправности' }
  },

  {
    path: 'electronic-control-room/detailed-malfunction-types',
    name: 'ElectronicControlRoom.DetailedMalfunctionTypes',
    component: () => import('~/views/electronic-control-room/lists/requests/DetailedMalfunctionTypes.vue'),
    meta: { title: 'Подробные виды неисправностей' }
  },
  {
    path: 'electronic-control-room/detailed-malfunction-types/detail/:id?',
    name: 'ElectronicControlRoom.DetailedMalfunctionType',
    component: () => import('~/views/electronic-control-room/list-items/requests/DetailedMalfunctionType.vue'),
    meta: { title: 'Подробный вид неисправности' }
  },

  {
    path: 'electronic-control-room/divisions',
    name: 'Divisions',
    component: () => import('~/views/electronic-control-room/lists/requests/Divisions.vue'),
    meta: { title: 'Подразделения' }
  },
  {
    path: 'electronic-control-room/divisions/detail/:id?',
    name: 'Division',
    component: () => import('~/views/electronic-control-room/list-items/requests/Division.vue'),
    meta: { title: 'Подразделение' }
  },

  {
    path: 'electronic-control-room/request-pools',
    name: 'RequestPools',
    component: () => import('~/views/electronic-control-room/lists/requests/RequestPools.vue'),
    meta: { title: 'Пулы заявок' }
  },
  {
    path: 'electronic-control-room/request-pools/detail/:id?',
    name: 'RequestPool',
    component: () => import('~/views/electronic-control-room/list-items/requests/RequestPool.vue'),
    meta: { title: 'Пул заявок' }
  },

  {
    path: 'electronic-control-room/email-gates',
    name: 'EmailGates',
    component: () => import('~/views/electronic-control-room/lists/requests/EmailGates.vue'),
    meta: { title: 'Email-источников заявок' }
  },
  {
    path: 'electronic-control-room/email-gates/detail/:id?',
    name: 'EmailGate',
    component: () => import('~/views/electronic-control-room/list-items/requests/EmailGate.vue'),
    meta: { title: 'Email-источник заявки' }
  },

  {
    path: 'electronic-control-room/email-gate-filters',
    name: 'EmailGateFilters',
    component: () => import('~/views/electronic-control-room/lists/requests/EmailGateFilters.vue'),
    meta: { title: 'Email правила фильтрации' }
  },
  {
    path: 'electronic-control-room/email-gate-filters/detail/:id?',
    name: 'EmailGateFilter',
    component: () => import('~/views/electronic-control-room/list-items/requests/EmailGateFilter.vue'),
    meta: { title: 'Email правило фильтрации' }
  },

  {
    path: 'electronic-control-room/to-shareholder-telegram-subjects',
    name: 'ElectronicControlRoom.ToShareholderTelegramSubjects',
    component: () => import('~/views/electronic-control-room/lists/requests/ToShareholderTelegramSubjects.vue'),
    meta: { title: 'Темы обращений к директору в Телеграм' }
  },
  {
    path: 'electronic-control-room/to-shareholder-telegram-subjects/detail/:id?',
    name: 'ElectronicControlRoom.ToShareholderTelegramSubject',
    component: () => import('~/views/electronic-control-room/list-items/requests/ToShareholderTelegramSubject.vue'),
    meta: { title: 'Тема обращения к директору в Телеграм' }
  },

  {
    path: 'electronic-control-room/emergency-request-channels',
    name: 'EmergencyRequestChannels',
    component: () => import('~/views/electronic-control-room/lists/requests/EmergencyRequestChannels.vue'),
    meta: { title: 'Группы для отправки аварийных заявок' }
  },
  {
    path: 'electronic-control-room/emergency-request-channels/detail/:id?',
    name: 'EmergencyRequestChannel',
    component: () => import('~/views/electronic-control-room/list-items/requests/EmergencyRequestChannel.vue'),
    meta: { title: 'Группа для отправки аварийных заявок' }
  },

  {
    path: 'electronic-control-room/help-dispatcher-general',
    name: 'HelpDispatcherGeneral',
    component: () => import('~/views/electronic-control-room/lists/requests/HelpDispatcherGeneral.vue'),
    meta: { title: 'Информация в помощь диспетчеру (список)' }
  },
  {
    path: 'electronic-control-room/help-dispatcher-general/detail/:id?',
    name: 'HelpDispatcherDetail',
    component: () => import('~/views/electronic-control-room/list-items/requests/HelpDispatcherDetail.vue'),
    meta: { title: 'Информация в помощь диспетчеру' }
  },

  {
    path: 'electronic-control-room/employment-calendar',
    name: 'EmploymentCalendar',
    component: () => import('~/views/electronic-control-room/lists/requests/EmploymentCalendar.vue'),
    meta: { title: 'График работы сотрудников (список)' }
  },
  {
    path: 'electronic-control-room/employment-calendar/detail/:id?',
    name: 'EmploymentCalendarDetail',
    component: () => import('~/views/electronic-control-room/list-items/requests/EmploymentCalendarDetail.vue'),
    meta: { title: 'График работы сотрудников' }
  },

  {
    path: 'electronic-control-room/employment-calendar/detail/:id/graph',
    name: 'ElectronicControlRoom.EmploymentCalendarGraph',
    component: () => import('~/views/electronic-control-room/list-items/requests/EmploymentCalendarGraph.vue'),
    meta: { title: 'График работы сотрудников' }
  },

  {
    path: 'electronic-control-room/auto-move-settings',
    name: 'ElectronicControlRoom.AutoMoveSettings',
    component: () => import('~/views/electronic-control-room/lists/requests/AutoMoveSettings.vue'),
    meta: { title: 'Настройки для автоперевода заявок' }
  },

  {
    path: 'electronic-control-room/auto-move-settings/detail/:id?',
    name: 'ElectronicControlRoom.AutoMoveSettingsDetail',
    component: () => import('~/views/electronic-control-room/list-items/requests/AutoMoveSettingsDetail.vue'),
    meta: { title: 'Настройка для автоперевода заявок' }
  },

  {
    path: 'electronic-control-room/auto-move-settings/detail/:parentId/auto-move-settings-log',
    name: 'ElectronicControlRoom.AutoMoveSettingsLogDetails',
    component: () => import('~/views/electronic-control-room/lists/requests/AutoMoveSettingsLog.vue'),
    meta: { title: 'Логи изменений настроек автоперевода' }
  },

  {
    path: 'electronic-control-room/auto-subscription-for-overdue',
    name: 'ElectronicControlRoom.AutoSubscriptionForOverdue',
    component: () => import('~/views/electronic-control-room/lists/requests/AutoSubscriptionForOverdue.vue'),
    meta: { title: 'Настройки автоподключения к просроченным заявкам' }
  },

  {
    path: 'electronic-control-room/auto-subscription-for-overdue/detail/:id?',
    name: 'ElectronicControlRoom.AutoSubscriptionForOverdueDetail',
    component: () => import('~/views/electronic-control-room/list-items/requests/AutoSubscriptionForOverdueDetail.vue'),
    meta: { title: 'Настройка автоподключения к просроченным заявкам' }
  },

  {
    path: 'electronic-control-room/auto-observers-settings',
    name: 'AutoObserversSettings',
    component: () => import('~/views/electronic-control-room/lists/requests/AutoObserversSettings.vue'),
    meta: { title: 'Автоматически подключаемые к заявке наблюдатели' }
  },

  {
    path: 'electronic-control-room/auto-observers-settings/detail/:id?',
    name: 'AutoObserversSetting',
    component: () => import('~/views/electronic-control-room/list-items/requests/AutoObserversSetting.vue'),
    meta: { title: 'Автоматически подключаемые к заявке наблюдатель' }
  },

  {
    path: 'electronic-control-room/auto-move-low-mark',
    name: 'ElectronicControlRoom.AutoMoveLowMark',
    component: () => import('~/views/electronic-control-room/lists/requests/AutoMoveLowMark.vue'),
    meta: { title: 'Настройки автоперевода заявок с низкой оценкой' }
  },

  {
    path: 'electronic-control-room/auto-move-low-mark/detail/:id?',
    name: 'ElectronicControlRoom.AutoMoveLowMarkDetail',
    component: () => import('~/views/electronic-control-room/list-items/requests/AutoMoveLowMarkDetail.vue'),
    meta: { title: 'Настройка автоперевода заявок с низкой оценкой' }
  },

  {
    path: 'electronic-control-room/request-additional-fields',
    name: 'ElectronicControlRoom.RequestAdditionalFields',
    component: () => import('~/views/electronic-control-room/lists/requests/RequestAdditionalFields.vue'),
    meta: { title: 'Дополнительные поля заявок' }
  },
  {
    path: 'electronic-control-room/request-additional-fields/detail/:id?',
    name: 'ElectronicControlRoom.RequestAdditionalField',
    component: () => import('~/views/electronic-control-room/list-items/requests/RequestAdditionalField.vue'),
    meta: { title: 'Дополнительные поля для заявки' }
  },

  {
    path: 'electronic-control-room/task-types',
    name: 'TaskTypes',
    component: () => import('~/views/electronic-control-room/lists/requests/TaskTypes.vue'),
    meta: { title: 'Типы задач' }
  },
  {
    path: 'electronic-control-room/task-types/detail/:id?',
    name: 'TaskType',
    component: () => import('~/views/electronic-control-room/list-items/requests/TaskType.vue'),
    meta: { title: 'Тип задачи' }
  },

  {
    path: 'electronic-control-room/requests/request-type-groups',
    name: 'RequestTypeGroups',
    component: () => import('~/views/electronic-control-room/lists/requests/RequestTypeGroups.vue'),
    meta: { title: 'Группы типа заявок' }
  },
  {
    path: 'electronic-control-room/requests/request-type-groups/detail/:id?',
    name: 'RequestTypeGroup',
    component: () => import('~/views/electronic-control-room/list-items/requests/RequestTypeGroup.vue'),
    meta: { title: 'Группа типа заявок' }
  },
  {
    path: 'electronic-control-room/requests/customizable-selections',
    name: 'CustomizableSelections',
    component: () => import('~/views/electronic-control-room/lists/requests/CustomizableSelections.vue'),
    meta: { title: 'Настраиваемые отборы заявок' }
  },
  {
    path: 'electronic-control-room/requests/customizable-selections/detail/:id?',
    name: 'CustomizableSelection',
    component: () => import('~/views/electronic-control-room/list-items/requests/CustomizableSelection.vue'),
    meta: { title: 'Настраиваемый отбор заявок' }
  },
  // Workspace

  {
    path: 'electronic-control-room/emergency-works',
    name: 'EmergencyWorks',
    component: () => import('~/views/electronic-control-room/lists/workspace/EmergencyWorks.vue'),
    meta: { title: 'Аварийные работы' }
  },

  {
    path: 'electronic-control-room/emergency-works/detail/:id?',
    name: 'EmergencyWork',
    component: () => import('~/views/electronic-control-room/list-items/workspace/EmergencyWork.vue'),
    meta: { title: 'Аварийная работа' }
  },

  // Calls

  {
    path: 'electronic-control-room/calls',
    name: 'Calls',
    component: () => import('~/views/electronic-control-room/lists/calls/Calls.vue'),
    meta: { title: 'Журнал звонков' }
  },

  {
    path: 'electronic-control-room/missed-calls',
    name: 'MissedCalls',
    component: () => import('~/views/electronic-control-room/lists/calls/MissedCalls.vue'),
    meta: { title: 'Пропущенные звонки' }
  },
  {
    path: 'electronic-control-room/missed-calls/detail/:id?',
    name: 'MissedCall',
    component: () => import('~/views/electronic-control-room/list-items/calls/MissedCall.vue'),
    meta: { title: 'Пропущенный звонок' }
  },

  {
    path: 'electronic-control-room/voip-users-common-list',
    name: 'VoipUsersCommonList',
    component: () => import('~/views/electronic-control-room/lists/calls/VoipUsersCommonList.vue'),
    meta: { title: 'Общий список пользователей телефонии' }
  },
  {
    path: 'electronic-control-room/voip-users-common-list/detail/:id?',
    name: 'VoipUser',
    component: () => import('~/views/electronic-control-room/list-items/calls/VoipUser.vue'),
    meta: { title: 'Пользователь телефонии' }
  },

  {
    path: 'electronic-control-room/support-acceptor-phones',
    name: 'SupportAcceptorPhones',
    component: () => import('~/views/electronic-control-room/lists/calls/SupportAcceptorPhones.vue'),
    meta: { title: 'Параметры входящих номеров по событиям от АТС' }
  },
  {
    path: 'electronic-control-room/support-acceptor-phones/detail/:id?',
    name: 'SupportAcceptorPhone',
    component: () => import('~/views/electronic-control-room/list-items/calls/SupportAcceptorPhone.vue'),
    meta: { title: 'Параметр входящих номеров по событиям от АТС' }
  },

  // objects-of-control
  {
    path: 'electronic-control-room/control-objects',
    name: 'ElectronicControlRoom.ControlObjects',
    component: () => import('~/views/electronic-control-room/lists/controlObjects/ControlObjects.vue'),
    meta: { title: 'Объекты контроля' }
  },
  {
    path: 'electronic-control-room/control-objects/detail/:id?',
    name: 'ControlObject',
    component: () => import('~/views/electronic-control-room/list-items/control-objects/ControlObject.vue'),
    meta: { title: 'Объект контроля' }
  },

  {
		path: 'electronic-control-room/control-objects/control-object-results/:id',
		name: 'ControlObjectResultsForControllObject',
		component: () =>
			import(
				'~/views/electronic-control-room/list-items/control-objects/ControlObjectResultsForControllObject.vue'
			),
		meta: { title: 'Результаты осмотра' }
	},

  {
    path: 'electronic-control-room/acceptance-check-list',
    name: 'ElectronicControlRoom.AcceptanceCheckLists',
    component: () => import('~/views/electronic-control-room/lists/controlObjects/AcceptanceCheckList.vue'),
    meta: { title: 'Настройка чек-листа приемки' }
  },
  {
    path: 'electronic-control-room/acceptance-check-list/detail/:id?',
    name: 'ElectronicControlRoom.AcceptanceCheckList',
    component: () => import('~/views/electronic-control-room/list-items/control-objects/AcceptanceCheckList.vue'),
    meta: { title: 'Чек-лист приемки помещений' }
  },
  // Settings

  {
    path: 'electronic-control-room/phones-comments',
    name: 'PhonesComments',
    component: () => import('~/views/electronic-control-room/lists/settings/PhonesComments.vue'),
    meta: { title: 'Комментарии к телефонным номерам' }
  },
  {
    path: 'electronic-control-room/phones-comments/detail/:id?',
    name: 'PhonesComment',
    component: () => import('~/views/electronic-control-room/list-items/settings/PhonesComment.vue'),
    meta: { title: 'Комментарий к телефонному номеру' }
  },

  {
    path: 'electronic-control-room/daily-work-schedule',
    name: 'DailyWorkSchedule',
    component: () => import('~/views/electronic-control-room/lists/settings/DailyWorkSchedule.vue'),
    meta: { title: 'Ежедневное расписание работы' }
  },
  {
    path: 'electronic-control-room/daily-work-schedule/detail/:id?',
    name: 'DailyWorkScheduleItem',
    component: () => import('~/views/electronic-control-room/list-items/settings/DailyWorkScheduleItem.vue'),
    meta: { title: 'Расписание работы' }
  },
  
  {
    path: 'electronic-control-room/support-settings',
    name: 'ElectronicControlRoom.SupportSettings',
    component: () => import('~/views/electronic-control-room/list-items/settings/support-settings/SupportSettings.vue'),
    meta: { title: 'Настройки диспетчерской службы' }
  },

  {
    path: 'electronic-control-room/support-settings/support-settings-change-log',
    name: 'ElectronicControlRoom.SupportSettingsChangeLog',
    component: () => import('~/views/electronic-control-room/lists/settings/SupportSettingsChangeLog.vue'),
    meta: { title: 'Логи изменений настроек диспетчерской службы' }
  },

  {
    path: 'electronic-control-room/support-settings/robot-settings-change-log',
    name: 'ElectronicControlRoom.RobotSettingsChangeLog',
    component: () => import('~/views/electronic-control-room/lists/settings/RobotSettingsChangeLog.vue'),
    meta: { title: 'Логи изменений настроек робота диспетчера' }
  },

  // Users

  {
    path: 'electronic-control-room/users',
    name: 'Users',
    component: () => import('~/views/electronic-control-room/lists/users/Users.vue'),
    meta: { title: 'Пользователи' }
  },
  {
    path: 'electronic-control-room/users/detail/:id?',
    name: 'User',
    component: () => import('~/views/electronic-control-room/list-items/users/User.vue'),
    meta: { title: 'Пользователь' }
  },

  {
    path: 'electronic-control-room/users/user-roles-for-account/:id?',
    name: 'RoofUserRolesForAccount',
    component: () => import('~/views/access/lists/RoofUserRolesForAccount.vue'),
    meta: { title: 'Роли, назначенные пользователям в базе' }
  },
  {
    path: 'electronic-control-room/users/user-roles-for-account/:parentId/edit/detail/:id?',
    name: 'RoofUserRoleForAccount',
    component: () => import('~/views/access/list-items/RoofUserRoleForAccount.vue'),
    meta: { title: 'Роль, назначенная пользователю в базе' }
  },

  {
    path: 'electronic-control-room/house-groups',
    name: 'HouseGroups',
    component: () => import('~/views/electronic-control-room/lists/users/HouseGroups.vue'),
    meta: { title: 'Группы домов' }
  },
  {
    path: 'electronic-control-room/house-groups/detail/:id?',
    name: 'HouseGroup',
    component: () => import('~/views/electronic-control-room/list-items/users/HouseGroup.vue'),
    meta: { title: 'Группа домов' }
  },

  // Passes

  {
    path: 'electronic-control-room/passes',
    name: 'Passes',
    component: () => import('~/views/electronic-control-room/lists/passes/Passes.vue'),
    meta: { title: 'Пропуска' }
  },

  {
    path: 'electronic-control-room/pass-categories',
    name: 'PassCategories',
    component: () => import('~/views/electronic-control-room/lists/passes/PassCategories.vue'),
    meta: { title: 'Категории пропусков' }
  },
  {
    path: 'electronic-control-room/pass-categories/detail/:id?',
    name: 'PassCategory',
    component: () => import('~/views/electronic-control-room/list-items/passes/PassCategory.vue'),
    meta: { title: 'Категория пропусков' }
  },

  {
    path: 'electronic-control-room/vehicle-number-templates',
    name: 'VehicleNumberTemplates',
    component: () => import('~/views/electronic-control-room/lists/passes/VehicleNumberTemplates.vue'),
    meta: { title: 'Шаблоны номеров автотранспорта' }
  },

  {
    path: 'electronic-control-room/vehicle-number-templates/detail/:id?',
    name: 'VehicleNumberTemplate',
    component: () => import('~/views/electronic-control-room/list-items/passes/VehicleNumberTemplate.vue'),
    meta: { title: 'Шаблон номеров автотранспорта' }
  },

  {
    path: 'electronic-control-room/vehicle-marks',
    name: 'VehicleMarks',
    component: () => import('~/views/electronic-control-room/lists/passes/VehicleMarks.vue'),
    meta: { title: 'Марки автомобилей' }
  },
  {
    path: 'electronic-control-room/vehicle-marks/detail/:id?',
    name: 'VehicleMark',
    component: () => import('~/views/electronic-control-room/list-items/passes/VehicleMark.vue'),
    meta: { title: 'Марка автомобиля' }
  },

  {
    path: 'electronic-control-room/black-list-car-numbers',
    name: 'BlackListCarNumbers',
    component: () => import('~/views/electronic-control-room/lists/passes/BlackListCarNumbers.vue'),
    meta: { title: 'Черный список автотранспорта' }
  },
  {
    path: 'electronic-control-room/black-list-car-numbers/detail/:id?',
    name: 'BlackListCarNumber',
    component: () => import('~/views/electronic-control-room/list-items/passes/BlackListCarNumber.vue'),
    meta: { title: 'Автотранспорт для черного списка' }
  },

  {
    path: 'electronic-control-room/black-list-idents',
    name: 'BlackListIdents',
    component: () => import('~/views/electronic-control-room/lists/passes/BlackListIdents.vue'),
    meta: { title: 'Черный список лицевых счетов' }
  },
  {
    path: 'electronic-control-room/black-list-idents/detail/:id?',
    name: 'BlackListIdent',
    component: () => import('~/views/electronic-control-room/list-items/passes/BlackListIdent.vue'),
    meta: { title: 'Лицевой счет в черный список' }
  },

  // Document Types

  {
    path: 'electronic-control-room/document-types',
    name: 'DocumentTypes',
    component: () => import('~/views/electronic-control-room/lists/documentTypes/DocumentTypes.vue'),
    meta: { title: 'Типы документов' }
  },
  {
    path: 'electronic-control-room/document-types/detail/:id?',
    name: 'DocumentType',
    component: () => import('~/views/electronic-control-room/list-items/document-types/DocumentType.vue'),
    meta: { title: 'Тип документа' }
  },

  // Templates

  {
    path: 'electronic-control-room/support-pattern-texts',
    name: 'SupportPatternTexts',
    component: () => import('~/views/electronic-control-room/lists/templates/SupportPatternTexts.vue'),
    meta: { title: 'Шаблонные ответы диспетчера' }
  },
  {
    path: 'electronic-control-room/support-pattern-texts/detail/:id?',
    name: 'SupportPatternText',
    component: () => import('~/views/electronic-control-room/list-items/templates/SupportPatternText.vue'),
    meta: { title: 'Шаблонный ответ диспетчера' }
  },

  {
    path: 'electronic-control-room/support-notification-templates',
    name: 'SupportNotificationTemplates',
    component: () => import('~/views/electronic-control-room/lists/templates/SupportNotificationTemplates.vue'),
    meta: { title: 'Шаблоны уведомлений' }
  },
  {
    path: 'electronic-control-room/support-notification-templates/detail/:id?',
    name: 'SupportNotificationTemplate',
    component: () => import('~/views/electronic-control-room/list-items/templates/SupportNotificationTemplates.vue'),
    meta: { title: 'Шаблон уведомления' }
  },

  {
    path: 'electronic-control-room/ads-doc-templates',
    name: 'AdsDocTemplates',
    component: () => import('~/views/electronic-control-room/lists/templates/AdsDocTemplates.vue'),
    meta: { title: 'Шаблоны документов' }
  },
  {
    path: 'electronic-control-room/ads-doc-templates/detail/:id?',
    name: 'AdsDocTemplate',
    component: () => import('~/views/electronic-control-room/list-items/templates/AdsDocTemplate.vue'),
    meta: { title: 'Шаблон документа' }
  },

    {
    path: 'electronic-control-room/ads-how-to-create-template',
    name: 'AdsDocsHowCreateTemplate',
    component: () => import('~/views/electronic-control-room/lists/templates/AdsDocsHowCreateTemplate.vue'),
    meta: { title: 'Как создать шаблон?' }
  },
  // Phonograms
  {
    path: 'electronic-control-room/phonogram-types',
    name: 'PhonogramTypes',
    component: () => import('~/views/electronic-control-room/lists/phonograms/PhonogramTypes.vue'),
    meta: { title: 'Типы телефонограмм' }
  },
  {
    path: 'electronic-control-room/phonogram-types/detail/:id?',
    name: 'PhonogramType',
    component: () => import('~/views/electronic-control-room/list-items/phonograms/PhonogramType.vue'),
    meta: { title: 'Тип телефонограммы' }
  },

  // works and materials
  {
    path: 'electronic-control-room/materials-types',
    name: 'MaterialTypes',
    component: () => import('~/views/electronic-control-room/lists/materials/MaterialTypes.vue'),
    meta: { title: 'Типы материалов' }
  },
  {
    path: 'electronic-control-room/materials-types/detail/:id?',
    name: 'MaterialType',
    component: () => import('~/views/electronic-control-room/list-items/materials/MaterialType.vue'),
    meta: { title: 'Тип материала' }
  },

  {
    path: 'electronic-control-room/material-journal',
    name: 'MaterialJournal',
    component: () => import('~/views/electronic-control-room/lists/materials/MaterialJournal.vue'),
    meta: { title: 'Приходы материалов' }
  },
  {
    path: 'electronic-control-room/material-journal/detail/:id?',
    name: 'MaterialJournalItem',
    component: () => import('~/views/electronic-control-room/list-items/materials/MaterialJournal.vue'),
    meta: { title: 'Приход материалов' }
  },

  {
    path: 'electronic-control-room/list-of-works',
    name: 'ElectronicControlRoom.ListOfWorks',
    component: () => import('~/views/electronic-control-room/lists/materials/ListOfWorks.vue'),
    meta: { title: 'Список работ' }
  },
  {
    path: 'electronic-control-room/list-of-works/detail/:id?',
    name: 'ElectronicControlRoom.ListOfWorksItem',
    component: () => import('~/views/electronic-control-room/list-items/materials/ListOfWorksItem.vue'),
    meta: { title: 'Работа' }
  },
  {
    path: 'electronic-control-room/import-list-of-works',
    name: 'ElectronicControlRoom.ImportListOfWorks',
    component: () => import('~/views/electronic-control-room/file-analysis/ImportListOfWorks.vue'),
    meta: { title: 'Загрузка списка работ' }
  },
  {
    path: 'electronic-control-room/gis-ads-auto-task-pack/detail/:id?',
    name: 'GisAdsAutoTaskPackItem',
    component: () => import('~/views/electronic-control-room/list-items/integration/GisAdsAutoTaskPackItem.vue'),
    meta: { title: 'Периодические задачи обмена с ГИС ЖКХ и ЕДС МО' }
  },
  
  //Маршрутизация
  {
    path: 'electronic-control-room/requests-routes',
    name: 'ElectronicControlRoom.RequestsRoutes',
    component: () => import('~/views/electronic-control-room/lists/routing/RequestsRoutes.vue'),
    meta: { title: 'Маршруты заявок' }
  },
  {
    path: 'electronic-control-room/requests-routes/detail/:id?',
    name: 'ElectronicControlRoom.RequestsRoute',
    component: () => import('~/views/electronic-control-room/list-items/routing/RequestsRoute.vue'),
    meta: { title: 'Маршрут заявок' }
  },
	{
    path: 'electronic-control-room/requests-routes/detail/:parentId/requests-routes-actions',
    name: 'ElectronicControlRoom.RequestsRouteActions',
    component: () => import('~/views/electronic-control-room/lists/routing/RequestsRouteActions.vue'),
    meta: { title: 'Действия маршрута заявок' }
  },
  {
    path: 'electronic-control-room/requests-routes/detail/:parentId/requests-routes-actions/detail/:id?',
    name: 'ElectronicControlRoom.RequestsRouteAction',
    component: () => import('~/views/electronic-control-room/list-items/routing/RequestsRouteAction.vue'),
    meta: { title: 'Действие маршрута заявок' }
  },
  // gis ads auto-task pack
  {
    path: 'electronic-control-room/gis-ads-auto-task-pack',
    name: 'Integration.GisAdsAutoTaskPack',
    component: () => import('~/views/electronic-control-room/lists/integration/GisAdsAutoTaskPack.vue'),
    meta: { title: 'Периодические задачи обмена с ГИС ЖКХ и ЕДС МО' }
  },
  {
    path: 'electronic-control-room/gis-ads-auto-task-pack/detail/:id?',
    name: 'Integration.GisAdsAutoTaskPackItem',
    component: () => import('~/views/electronic-control-room/list-items/integration/GisAdsAutoTaskPackItem.vue'),
    meta: { title: 'Периодическая задача обмена с ГИС ЖКХ и ЕДС МО' }
  },


  /* -------------------------------------------------------------------------*/
  /* Imports                                                                  */
  /* -------------------------------------------------------------------------*/

  {
    path: 'electronic-control-room/vehicle-marks/import',
    name: 'ImportVehicleMarks',
    component: () => import('~/views/electronic-control-room/file-analysis/ImportVehicleMarks.vue'),
    meta: { title: 'Загрузка марок автомобилей' }
  },
  {
    path: 'electronic-control-room/black-list-car-number/import',
    name: 'ImportBlacklistCarNumbers',
    component: () => import('~/views/electronic-control-room/file-analysis/ImportBlacklistCarNumbers.vue'),
    meta: { title: 'Загрузка черного списка автотранспорта' }
  },
  {
    path: 'electronic-control-room/black-list-ident/import',
    name: 'ImportBlackListIdents',
    component: () => import('~/views/electronic-control-room/file-analysis/ImportBlackListIdents.vue'),
    meta: { title: 'Загрузка черного списка лицевых счетов' }
  },
  // Long process
  {
    path: 'electronic-control-room/accounts/fill-template-tko-accounts-processor',
    name: 'ElectronicControlRoom.FillTemplateTKOAccountsProcessor',
    component: () => import('~/components/view/common/long-process/FillTemplateTKOAccountsProcessor.vue'),
    meta: { title: 'Выгрузить ЛС ТКО' }
  },
  {
    path: 'electronic-control-room/accounts/accounts-csv-file-processor',
    name: 'ElectronicControlRoom.AccountsCsvFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsCsvFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в CSV' }
  },
  {
    path: 'electronic-control-room/accounts/accounts-excel-file-processor',
    name: 'ElectronicControlRoom.AccountsExcelFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsExcelFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в Excel' }
  },
  {
    path: 'electronic-control-room/accounts/create-cr-accounts-processor',
    name: 'ElectronicControlRoom.CreateCRAccountsProcessor',
    component: () => import('~/components/view/common/long-process/CreateCRAccountsProcessor.vue'),
    meta: { title: 'Создать лицевые счета для кап.ремонта' }
  },
  {
    path: 'electronic-control-room/accounts/account-from-tko-template-processor',
    name: 'ElectronicControlRoom.AccountFromTkoTemplateProcessor',
    component: () => import('~/components/view/common/long-process/AccountFromTkoTemplateProcessor.vue'),
    meta: { title: 'Обновить ИЖКУ по результатам обработки шаблона ЛС ТКО' }
  },
	{
    path: 'electronic-control-room/accounts/detail/:parentId/mobile-accounts-for-account',
    name: 'ElectronicControlRoom.MobileAccountsForAccount',
    component: () => import('~/views/electronic-control-room/lists/addresses/MobileAccountsForAccount.vue'),
    meta: { title: 'Мобильные аккаунты' }
  },
  {
    path: 'electronic-control-room/accounts/detail/:parentId/mobile-accounts-for-account/detail/:id?',
    name: 'ElectronicControlRoom.MobileAccountForAccount',
    component: () => import('~/views/electronic-control-room/list-items/addresses/MobileAccountForAccount.vue'),
    meta: { title: 'Мобильный аккаунт' }
  },
  {
    path: 'electronic-control-room/accounts/detail/:parentId/bills-for-account',
    name: 'ElectronicControlRoom.BillsForAccount',
    component: () => import('~/views/electronic-control-room/lists/addresses/BillsForAccount.vue'),
    meta: { title: 'Квитанции' }
  },
  {
    path: 'electronic-control-room/accounts/detail/:parentId/meters-for-account',
    name: 'ElectronicControlRoom.MetersForAccount',
    component: () => import('~/views/electronic-control-room/lists/addresses/MetersForAccount.vue'),
    meta: { title: 'Приборы учета' }
  },
  {
    path: 'electronic-control-room/accounts/detail/:parentId/notification-send-logs-for-account',
    name: 'ElectronicControlRoom.NotificationSendLogsForAccount',
    component: () => import('~/views/electronic-control-room/lists/addresses/NotificationSendLogsForAccount.vue'),
    meta: { title: 'Логи уведомлений' }
  },
  {
    path: 'electronic-control-room/accounts/detail/:parentId/claimants-for-account',
    name: 'ElectronicControlRoom.ClaimantsForAccount',
    component: () => import('~/views/electronic-control-room/lists/addresses/ClaimantsForAccount.vue'),
    meta: { title: 'Взыскатели' }
  },
  {
    path: 'electronic-control-room/accounts/detail/:parentId/claimants-for-account/detail/:id?',
    name: 'ElectronicControlRoom.ClaimantForAccount',
    component: () => import('~/views/electronic-control-room/list-items/addresses/ClaimantForAccount.vue'),
    meta: { title: 'Взыскатель' }
  },
  {
    path: 'electronic-control-room/export-houses-to-excel-processor',
    name: 'ExportHousesToExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesToExcelProcessor.vue'),
    meta: { title: 'Выгрузить доп. информацию по домам (XLSX)' }
  },
  {
    path: 'electronic-control-room/export-houses-without-fias-processor',
    name: 'ExportHousesWithoutFiasProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesWithoutFiasProcessor.vue'),
    meta: { title: 'Выгрузить дома без ФИАС в CSV файл' }
  },
  {
    path: 'electronic-control-room/house-creation-master-processor',
    name: 'HouseCreationMasterProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseCreationMasterProcessor.vue'),
    meta: { title: 'Мастер создания дома' }
  },
  {
    path: 'electronic-control-room/house-fiases-processor',
    name: 'HouseFiasesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseFiasesProcessor.vue'),
    meta: { title: 'Загрузить ФИАСы' }
  },
  {
    path: 'electronic-control-room/houses-for-tko-contract-processor',
    name: 'HousesForTkoContractProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HousesForTkoContractProcessor.vue'),
    meta: { title: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)' }
  },
  {
    path: 'electronic-control-room/house-type-by-premise-type-processor',
    name: 'HouseTypeByPremiseTypeProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseTypeByPremiseTypeProcessor.vue'),
    meta: { title: 'Изменение типа домов по кол-ву помещений' }
  },
  {
    path: 'electronic-control-room/import-houses-from-excel-processor',
    name: 'ImportHousesFromExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ImportHousesFromExcelProcessor.vue'),
    meta: { title: 'Загрузить доп. информацию по домам (XLSX)' }
  },
  {
    path: 'electronic-control-room/premises-not-linked-to-account-remove-processor',
    name: 'PremisesNotLinkedToAccountRemoveProcessor',
    component: () => import('~/views/electronic-control-room/long-process/PremisesNotLinkedToAccountRemoveProcessor.vue'),
    meta: { title: 'Удалить помещения, не привязанные к ЛС' }
  },
  {
    path: 'electronic-control-room/update-houses-addresses-processor',
    name: 'UpdateHousesAddressesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/UpdateHousesAddressesProcessor.vue'),
    meta: { title: 'Обновление адресов домов' }
  },
  {
    path: 'electronic-control-room/fill-daily-work-schedule-processor',
    name: 'FillDailyWorkScheduleProcessor',
    component: () => import('~/views/electronic-control-room/long-process/FillDailyWorkScheduleProcessor.vue'),
    meta: { title: 'Заполнение графика работы организации' }
  },
  // {
  //   path: 'electronic-control-room/ads-employee-geolocation',
  //   name: 'SupportDispatchersGeolocating',
  //   component: () => import('~/views/electronic-control-room/long-process/SupportDispatchersGeolocating.vue'),
  //   meta: { title: 'Положение сотрудников' }
  // },
];